import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import StationeryPurchaseOrderListView from 'src/sections/stationery-purchase-order/view/stationery-purchase-order-list-view';

export default function StationeryPurchaseOrderListPage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Stationery Purchase Orders</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_STATIONERY_PURCHASE_ORDER,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <StationeryPurchaseOrderListView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
